module.exports = __webpack_public_path__ + "img/img1.06f0afb6.jpg";